import React, { useEffect, useState } from 'react';
import Nav from 'react-bootstrap/Nav';
import { useTranslate } from '@tolgee/react';

type Action = {
  label: string;
  onClick: () => void;
  active?: boolean;
  default?: boolean;
};

type AnalyticsNavbarProps = {
  actions: Action[];
};

const AnalyticsNavbar: React.FC<AnalyticsNavbarProps> = ({ actions }) => {
  const {t} = useTranslate()

  const [activeLabel, setActiveLabel] = useState<string>('');

  useEffect(() => {
    const hash = window.location.hash.replace('#', '');
    const found = actions.find(action => action.label === hash);
    if (found) {
      setActiveLabel(found.label);
      found.onClick();
    } else {
      const defaultAction = actions.find(action => action.default);
      if (defaultAction) {
        setActiveLabel(defaultAction.label);
        defaultAction.onClick();
        window.location.hash = defaultAction.label;
      }
    }
  }, [actions]);

  const handleClick = (action: Action) => {
    setActiveLabel(action.label);
    window.location.hash = action.label;
    action.onClick();
  };

  return (
    <div
      className="rounded bg-gray-300 d-flex flex-stack flex-wrap mb-9 p-2"
    >
      <Nav className="nav flex-wrap border-transparent" variant="pills">
        {actions.map((action, index) => (
          <Nav.Item className="nav-item my-1" key={index}>
            <button
              type="button"
              onClick={() => handleClick(action)}
              className={`btn btn-sm btn-color-gray-600 bg-state-body btn-active-color-gray-800 fw-bolder fw-bold fs-6 fs-lg-base nav-link px-3 px-lg-4 mx-1 ${
                activeLabel === action.label ? 'active' : ''
              }`}
            >
              {t(`nav.analytics.${action.label}`)}
            </button>
          </Nav.Item>
        ))}
      </Nav>
    </div>
  );
};

export default AnalyticsNavbar;
